import React, { useState, useEffect } from 'react';
import { API } from '../api';
import './ModelReactions.css';

const ModelReactions = () => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadModels = async () => {
      setLoading(true);
      try {
        const res = await API.stats.getModelsReactions();
        if (res.success) {
          // Sort by likes in descending order
          const sorted = (res.data || []).sort((a, b) => (b.likes || 0) - (a.likes || 0));
          setModels(sorted);
        } else {
          console.error('Failed to load model reactions:', res.error);
        }
      } catch (error) {
        console.error('Error loading model reactions:', error);
      } finally {
        setLoading(false);
      }
    };

    loadModels();
  }, []);

  if (loading) {
    return (
      <div className="tab-content">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Загрузка данных...</p>
        </div>
      </div>
    );
  }

  if (models.length === 0) {
    return (
      <div className="tab-content">
        <div className="model-reactions">
          <h2>Лайки/Дизлайки по моделям</h2>
          <div className="empty-message">Нет данных по моделям</div>
        </div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <div className="model-reactions">
        <h2>Лайки/Дизлайки по моделям</h2>
        
        <div className="models-table-wrapper">
          <table className="models-reactions-table">
            <thead>
              <tr>
                <th>Название модели</th>
                <th>Лайки</th>
                <th>Дизлайки</th>
                <th>Рейтинг</th>
                <th>Всего оценок</th>
              </tr>
            </thead>
            <tbody>
              {models.map((model) => {
                const modelLikes = model.likes || 0;
                const modelDislikes = model.dislikes || 0;
                const totalReactions = modelLikes + modelDislikes;
                const modelRate = totalReactions > 0
                  ? Math.round((modelLikes / totalReactions) * 100)
                  : 0;

                return (
                  <tr key={model.model} className="model-row">
                    <td className="model-name">
                      <span title={model.model}>{model.model || '—'}</span>
                    </td>
                    <td className="likes-cell">
                      <span className="likes-count" style={{ color: 'var(--success)' }}>
                        👍 {modelLikes.toLocaleString('ru-RU')}
                      </span>
                    </td>
                    <td className="dislikes-cell">
                      <span className="dislikes-count" style={{ color: 'var(--danger)' }}>
                        👎 {modelDislikes.toLocaleString('ru-RU')}
                      </span>
                    </td>
                    <td className="rating-cell">
                      <div className="rating-bar">
                        <div className="rating-percentage" title={`${modelRate}% лайков`}>
                          <span className="rating-value">{modelRate}%</span>
                          <div className="rating-progress">
                            <div 
                              className="progress-fill" 
                              style={{ 
                                width: `${modelRate}%`,
                                backgroundColor: modelRate >= 70 ? 'var(--success)' : modelRate >= 50 ? 'var(--warning)' : 'var(--danger)'
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="total-reactions">
                      {totalReactions.toLocaleString('ru-RU')}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Summary stats */}
        <div className="model-reactions-summary">
          <div className="summary-stat">
            <div className="stat-label">Всего моделей</div>
            <div className="stat-value">{models.length}</div>
          </div>
          <div className="summary-stat">
            <div className="stat-label" style={{ color: 'var(--success)' }}>Всего лайков</div>
            <div className="stat-value" style={{ color: 'var(--success)' }}>
              {models.reduce((sum, m) => sum + (Number(m.likes) || 0), 0).toLocaleString('ru-RU')}
            </div>
          </div>
          <div className="summary-stat">
            <div className="stat-label" style={{ color: 'var(--danger)' }}>Всего дизлайков</div>
            <div className="stat-value" style={{ color: 'var(--danger)' }}>
              {models.reduce((sum, m) => sum + (Number(m.dislikes) || 0), 0).toLocaleString('ru-RU')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelReactions;
